import {
  perimeterCameraAzimuthLayer,
  perimeterCameraSectorFillLayer,
  perimeterCameraSectorOutlineLayer,
} from '@components/map/layers/perimeterCameras/perimeterCamera.layer';
import { useMapContext } from '@components/map/MapContext';
import { createSensorLayerErrorToast } from '@components/ui/toaster/toaster';
import { useSelectorWithReplayMode } from '@hooks/useSelectorWithReplayMode';
import { selectPerimeterCameraSectorFeatures } from '@redux/situation/monitoring.selectors';
import { isFeatureCollection } from '@utils/map/map.utils';
import { ErrorBoundary } from 'react-error-boundary';
import { Layer, Source } from 'react-map-gl/mapbox';

import { MapIdEnum, SourceNameEnum } from '@/types/map.types';

function PerimeterCameraSectorLayerContent() {
  const perimeterCameraSectorFeatures = useSelectorWithReplayMode(selectPerimeterCameraSectorFeatures);

  if (!isFeatureCollection(perimeterCameraSectorFeatures)) return null;

  return (
    <Source id={SourceNameEnum.PERIMETER_CAMERA_SECTORS} type="geojson" data={perimeterCameraSectorFeatures}>
      <Layer {...perimeterCameraSectorFillLayer} />
      <Layer {...perimeterCameraSectorOutlineLayer} />
      <Layer {...perimeterCameraAzimuthLayer} />
    </Source>
  );
}

export default function PerimeterCameraSectorLayer() {
  const { mapId } = useMapContext();
  return mapId === MapIdEnum.REPLAY ? (
    <ErrorBoundary
      fallback={<></>}
      onError={() => createSensorLayerErrorToast(SourceNameEnum.PERIMETER_CAMERA_SECTORS)}
    >
      <PerimeterCameraSectorLayerContent />
    </ErrorBoundary>
  ) : (
    <PerimeterCameraSectorLayerContent />
  );
}
